import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {
      width: "400px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 24px",
      cursor: "pointer",
      transform: "scale(1)",
      transformOrigin: "center",
      transition: "transform 150ms ease, box-shadow 150ms ease",

      "& + &": {
        marginTop: "24px",
      },

      "&:hover": {
        transform: "scale(1.05)",
        boxShadow: `0px 2px 20px ${theme.colors.shadow}`,
      },

      "&:focus": {
        outline: `1px solid ${theme.colors.action}`,
        boxShadow: "none",
        borderRadius: "2px",
      },
    },
    content: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
    },
    tileHeader: {
      ...theme.fonts.h3,
      color: theme.colors.textDefault,
    },
    tileDescription: {
      ...theme.fonts.p2,
      color: theme.colors.textSubtle,
    },
    tileIcon: {
      color: theme.colors.action,
    },
    disabledButton: {},
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
